import sumItems from '../../../../../calculations/sumItems'

export default (items) => sumItems({ values: { items }})
